import React from 'react'
import Team from '../Components/About/Team'
const WhoAreWe = () => {
  return (
    <div>
      <Team/>
    </div>
  )
}

export default WhoAreWe